export default "__VITE_ASSET__DdZqjUBA__"